module.exports = __webpack_public_path__ + "static/img/11.4f8c1d19.png";